import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import { Container } from '../components/_atoms';
import { UserDTO } from '../DTO/UserDTO';
import { APIService } from '../services/apiService';
import { AdminLevels } from '../util/enumerations';
import LastEdited from '../components/lastEdited';

import {
	Button,
	FormControl,
	FormGroup,
	InputLabel,
	MenuItem,
	TextField,
} from '@mui/material';
import Select from '@mui/material/Select';
import { useIsDirty } from '../hooks/isDirty';

const StyledTextField = styled(TextField)(() => ({
	marginBottom: '12px',
	marginRight: '12px',
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
	margin: theme.spacing(1),
	minWidth: 120,
}));

const StyledSelect = styled(Select)(() => ({
	marginBottom: '12px',
	marginRight: '12px',
}));

const StyledButton = styled(Button)(() => ({
	margin: '12px 6px 18px 0',
}));

const User = () => {
	const params = useParams<{ id?: string }>();
	const userId: number = Number(params.id) || 0;
	const api = new APIService();

	const [user, setUser] = useState<UserDTO | null>(null);
	const [error, setError] = useState({ message: '' });
	const [isDirty, updateCleanValue] = useIsDirty(user);

	useEffect(() => {
		if (userId > 0) {
			api.getUserById(userId).then((data) => {
				setUser(data);
				updateCleanValue(data);
			});
		} else {
			const newUser = new UserDTO();
			setUser(newUser);
			updateCleanValue(newUser);
		}
	}, []);

	const handleSubmit = (event: React.FormEvent) => {
		if (!user) return;
		api.saveUser(user)
			.then((data) => {
				setUser(data);
				setError({ message: '' });
			})
			.catch((error) => {
				setError({ message: 'Error: ' + error.response.data.message });
			});

		if (event) event.preventDefault();
	};

	return !user ? (
		<h1>Could not find user</h1>
	) : (
		<Container>
			<h1>{user.name}</h1>
			<form onSubmit={handleSubmit}>
				<FormGroup row>
					<StyledTextField
						type="text"
						value={user.id}
						disabled={true}
						label="Id"
						variant="outlined"
					/>
					<StyledTextField
						type="text"
						value={user.isAdmin ? 'Yes' : 'No'}
						disabled={true}
						label="Admin"
						variant="outlined"
					/>
				</FormGroup>
				<FormGroup row>
					<StyledFormControl variant="outlined">
						<InputLabel id="level-select-label">Admin</InputLabel>
						<StyledSelect
							label="Admin"
							value={user.isAdmin ? '1' : '0'}
							labelId="level-select-label"
							onChange={(e) =>
								setUser(
									(prevUser) =>
										({
											...prevUser,
											isAdmin: Boolean(
												Number(e.target.value)
											),
										} as UserDTO)
								)
							}
						>
							{AdminLevels.map((u) => (
								<MenuItem
									value={u.isAdmin ? '1' : '0'}
									key={u.id}
								>
									{u.isAdmin ? 'Yes' : 'No'}
								</MenuItem>
							))}
						</StyledSelect>
					</StyledFormControl>
				</FormGroup>
				<br />
				<LastEdited data={user}></LastEdited>
				<StyledButton
					variant="contained"
					color="primary"
					size="small"
					type="submit"
					value="save"
					disabled={!isDirty}
				>
					Save
				</StyledButton>
				<p>{error.message}</p>
			</form>
		</Container>
	);
};

export default User;
